<template>
  <div v-show="isLoading">
    <div
      class="loading"
      style="background-color: #f7f7f785;"
    >
      <i
        class="fa-spin fas fa-spinner fa-4x"
        style="color: var(--primary);"
      />
    </div>
    <div
      v-if="showMessage"
      :class="['message', {'cor-letra': trocarCorLetra}]"
    >
      {{ showMessage }}
    </div>
    <div
      v-if="subtitulo"
      class="message-subtitulo"
    >
      {{ subtitulo }}
    </div>
    <b-button
      v-if="showCancelButton"
      variant="danger"
      class="button-cancel"
      @click="cancelar()"
    >
      Cancelar
    </b-button>
  </div>
</template>

<style scoped>
.loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading i {
  position: absolute;
  opacity: 1;
}

 .button-cancel {
   position: fixed;
   left: 42.5%;
   bottom: 5%;
   z-index: 99999 !important;
   width: 15%;
   display: flex;
   align-items: center;
   justify-content: center;
 }
 .message {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 125vh;
  z-index: 99999 !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color:rgb(0, 0, 0);
  font-weight: bold;
  font-size: 20px;
 }
.cor-letra{
  color: rgb(153,138,138);
}
  .message-subtitulo {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 35px;
    height: 135vh;
    z-index: 99999 !important;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(0, 0, 0);
    font-size: 15px;
    color: red;
    font-weight: bold;
  }
</style>

<script>

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: () => false,
    },
    cancelarUpload: {
      type: Function,
      default: () => {},
    },
    trocarCorLetra: {
      type: Boolean,
      default: () => false,
    },
    showCancelButton: {
      type: Boolean,
      default: () => true,
    },
    showMessage: {
      type: String,
      default: () => null,
    },
    subtitulo: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    cancelar() {
      this.cancelarUpload()
    },
  },
}
</script>
